import React from "react";
// import { BrowserRouter as Router, Switch, Route } from "react-router-dom"; //HashRouter,
import {
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import "normalize.css/normalize.css";
import "@blueprintjs/core/lib/css/blueprint.css";
import "./survey-ui/styles/setproduct.css";
import './survey-ui/styles/custom-style.css';
import 'react-toastify/dist/ReactToastify.css';
import Integrations from "./survey-ui/views/pages/survey/survey-form/integration/integration";
import EloquaSettings from "./survey-ui/views/pages/survey/survey-form/integration/EloquaSettings";
import ThankYouPages from "./survey-ui/views/pages/survey/survey-form/thankyou/ThankYouPages";
import Questionaire from "./survey-ui/views/pages/survey/survey-form/questionaire/Questionaire";
import Login from "./survey-ui/views/pages/Authentication/login/Login";
import ForgotPassword from "./survey-ui/views/pages/Authentication/forgot-password/ForgotPassword";
import ForgetPasswordConfirmation from "./survey-ui/views/pages/Authentication/forgot-password/ForgetPasswordConfirmation";
import VerifyEmail from "./survey-ui/views/pages/Authentication/forgot-password/VerifyEmail";
import ResetPassword from "./survey-ui/views/pages/Authentication/forgot-password/ResetPassword";
import PasswordChanged from "./survey-ui/views/pages/Authentication/forgot-password/PasswordChanged";
import SignUp from "./survey-ui/views/pages/Authentication/sign-up/SignUp";
import SignUpVerifyEmail from "./survey-ui/views/pages/Authentication/sign-up/VerifyEmail";
import EmailVerification from "./survey-ui/views/pages/Authentication/sign-up/EmailVerification";
import LoginOtpVerification from "./survey-ui/views/pages/Authentication/login/EmailVerification";
import AccountSetUp from "./survey-ui/views/pages/Authentication/sign-up/AccountSetUp";
import AccountSetUpGl from "./survey-ui/views/pages/Authentication/sign-up/AccountSetUpGl";
import OnBoardingScreen from "./survey-ui/views/pages/Authentication/sign-up/OnBoardingScreen";
import ProcessDone from "./survey-ui/views/pages/Authentication/sign-up/ProcessDone";
import TeamAccountSetUp from "./survey-ui/views/pages/Authentication/team-invitation/AccountSetUp";
import TeamOnBoardingScreen from "./survey-ui/views/pages/Authentication/team-invitation/OnBoardingScreen";
import TeamProcessDone from "./survey-ui/views/pages/Authentication/sign-up/ProcessDone";
import TeamVerification from "./survey-ui/views/pages/Authentication/team-invitation/TeamVerification";
import InvitationEmail from "./survey-ui/views/pages/Authentication/team-invitation/InvitationEmail";
import JoinExistingAccount from "./survey-ui/views/pages/Authentication/team-invitation/JoinExistingAccount";
import AccountSetUpSignUp from "./survey-ui/views/pages/Authentication/team-invitation/AccountSetUpSignUp";
import JoiningRequestExistingAccount from "./survey-ui/views/pages/Authentication/team-invitation/JoiningRequestExistingAccount";
import QnaTemplates from "./survey-ui/views/pages/survey/survey-form/build/qna/Index1";
import SurveyList from "./survey-ui/views/pages/survey/survey-list/Index";
import FormBuilder from "./survey-ui/views/pages/survey/survey-form/form-builder/Index";
import Variables from "./survey-ui/views/pages/survey/survey-form/variables/Index";
import CustomVariable from "./survey-ui/views/pages/survey/survey-form/variables/CustomVariable";
import CustomFormulas from "./survey-ui/views/pages/survey/survey-form/variables/CustomFormulas";
import UTMCampaignValues from "./survey-ui/views/pages/survey/survey-form/variables/UTMCampaignValues";
// import EditorMultipleChoice from "./survey-ui/component/common/EditorMultipleChoice";
import BuildOnBoarding from "./survey-ui/views/pages/survey/survey-form/build/LandingPage";
import Configuration from "./survey-ui/views/pages/survey/survey-form/configuration/Index";
import DefaultLanguage from "./survey-ui/views/pages/survey/survey-form/language/default-language/Index";
import Translation from "./survey-ui/views/pages/survey/survey-form/language/translation/Index";

import LandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/Index";
import SimpleLandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/SimpleLandingPage";
import DetailedLandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/DetailedLandingPage";
import SimpleFormLandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/SimpleFormLandingPage";
import WidgetFormLandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/WidgetFormLandingPage";
import Share from "./survey-ui/views/pages/survey/survey-form/share/Index";
import GroupShare from "./survey-ui/views/pages/survey/survey-group/share/Index";
import Preview from "./survey-ui/views/pages/survey/survey-form/preview/Index";
import ThankYouPreview from "./survey-ui/views/pages/survey/survey-form/preview/ThankYouPreview";
import Dashboard from "./survey-ui/views/pages/dashboard/Index";
import Profile from "./survey-ui/views/pages/settings/Profile";
import UserRoles from "./survey-ui/views/pages/settings/UserRoles";
import UserPermissions from "./survey-ui/views/pages/settings/UserPermissions";
import Teams from "./survey-ui/views/pages/settings/teams/Teams";
import CreateTeam from "./survey-ui/views/pages/settings/teams/Create";
import EditTeam from "./survey-ui/views/pages/settings/teams/Edit";
import Notifications from "./survey-ui/views/pages/settings/Notifications";
import SecuritySettings from "./survey-ui/views/pages/settings/SecuritySettings";
import TicketNotificationSettings from "./survey-ui/views/pages/settings/TicketNotificationSettings";
import OrganizationDetails from "./survey-ui/views/pages/settings/OrganizationDetails";
import MfaVerification from "./survey-ui/views/pages/Authentication/login/MfaVerification";
import PasswordExpired from "./survey-ui/views/pages/Authentication/login/PasswordExpired";
import TeamInvitation from "./survey-ui/views/pages/Authentication/team-invitation/Index";
import NewSurveyQuestionaire from "./survey-ui/views/pages/survey/survey-form/build/new-survey-questionaire/Index";
import Analytics from "./survey-ui/views/pages/analytics/Index";
import Index from "./survey-ui/views/pages/survey/survey-form/design/Index";
import Stages from "./survey-ui/views/pages/survey/survey-form/variables/Stages";
import Terms from "./survey-ui/views/pages/survey/survey-form/content-pages/Terms";
import PrivacyPolicies from "./survey-ui/views/pages/survey/survey-form/content-pages/PrivacyPolicies";
import CreateSurvey from "./survey-ui/views/pages/documentation/surveys/CreateSurvey";


import DocumentationSidebar from "./survey-ui/views/pages/documentation/component/DocumentationSidebar";
import DocumentDashboard from "./survey-ui/views/pages/documentation/surveys/Dashboard";
import DocumentFormBuilder from "./survey-ui/views/pages/documentation/surveys/FormBuilder";
import DocumentPublishShare from "./survey-ui/views/pages/documentation/surveys/PublishAndShare";
import DocumentIntegration from "./survey-ui/views/pages/documentation/surveys/integration";
import DocumentWebhook from "./survey-ui/views/pages/documentation/surveys/webhooks";
import DocumentQandABuilder from "./survey-ui/views/pages/documentation/surveys/QandABuilder";
import DocumentQuestionnarire from "./survey-ui/views/pages/documentation/surveys/Questionnaire";
import DocumentReportBuilder from "./survey-ui/views/pages/documentation/surveys/ReportBuilder";
import DocumentThankYouPage from "./survey-ui/views/pages/documentation/surveys/ThankYouPage";
import DocumentPrivacyPolicy from "./survey-ui/views/pages/documentation/surveys/PrivacyPolicy";
import DocumentVariables from "./survey-ui/views/pages/documentation/surveys/Variables";
import DocumentRecomadation from "./survey-ui/views/pages/documentation/surveys/Recomadation";
import DocumentSurveyGroups from "./survey-ui/views/pages/documentation/surveys/SurveyGroups";
import DocumentSurveySync from "./survey-ui/views/pages/documentation/surveys/SurveySync";
import DocumentEmailTemplates from "./survey-ui/views/pages/documentation/surveys/EmailTemplates";
import DocumentCookiePolicy from "./survey-ui/views/pages/documentation/surveys/CookiePolicy";
import DocumentLeadErasureRules from "./survey-ui/views/pages/documentation/surveys/LeadErasureRules";
import DocumentAccountSetting from "./survey-ui/views/pages/documentation/settings/AccountSetting";
import DocumentRoles from "./survey-ui/views/pages/documentation/settings/Roles";
import DocumentTeams from "./survey-ui/views/pages/documentation/settings/Teams";
import DocumentUsers from "./survey-ui/views/pages/documentation/settings/Users";
import DocumentSecuritySettings from "./survey-ui/views/pages/documentation/settings/SecuritySettings";
import DocumentTicketNotificationSettings from "./survey-ui/views/pages/documentation/settings/TicketNotificationSettings";
import DocumentOrganizationDetails from "./survey-ui/views/pages/documentation/settings/OrganizationDetails";
import DocumentAnalytics from "./survey-ui/views/pages/documentation/Analytics";
import DocumentActivityLog from "./survey-ui/views/pages/documentation/ActivityLogs";
import DocumentTickets from "./survey-ui/views/pages/documentation/Tickets";



import Fonts from "./survey-ui/views/pages/settings/Fonts";
import RecentReports from "./survey-ui/views/pages/survey/survey-form/report/RecentReports";
import Templates from "./survey-ui/views/pages/survey/survey-form/report/Templates";
import EmailTemplateEditor from "./survey-ui/views/pages/survey/survey-form/email-template/EmailTemplateEditor";
import QuestionLogic from "./survey-ui/views/pages/survey/survey-form/question-logic/Index";
import Webhooks from "./survey-ui/views/pages/survey/survey-form/configuration/Webhooks";
import LeadErasureRules from "./survey-ui/views/pages/survey/survey-form/configuration/LeadErasureRules";
import PrivacyPolicyNew from "./survey-ui/views/pages/survey/survey-form/configuration/PrivacyPolicyNew";
import CookiePolicyPage from "./survey-ui/views/pages/survey/survey-form/configuration/CookiePolicyPage";
import ActivityLogs from "./survey-ui/views/pages/Activitylogs";
import ActivityLogTemplate from "./survey-ui/views/pages/settings/ActivitylogsTemplate";
import { PersistGate } from 'redux-persist/integration/react'
import { Provider, useDispatch } from 'react-redux';
import store, { persistor } from "./survey-ui/store/store";
import AdminSurveyLayout from "./survey-ui/component/common/page-layout/AdminSurveyLayout";
import Leads from "./survey-ui/views/pages/analytics/Leads";
import ThankyouPage from "./survey-ui/views/pages/survey/survey-form/landing-page/ThankyouPage";
import DesignLandingPage from "./survey-ui/views/pages/survey/survey-form/landing-page/DesignLandingPage";
import DesignThankyouPage from "./survey-ui/views/pages/survey/survey-form/landing-page/DesignThankyouPage";
import { useEffect } from "react";
import { SET_SURVEY_ID, SET_SURVEY_NAME } from "./survey-ui/store/constant";
import { ToastContainer } from "react-toastify";
import SurveyGroup from "./survey-ui/views/pages/survey/survey-group/Index";
import GroupSurveyList from "./survey-ui/views/pages/survey/survey-group/GroupSurveyList";

import "react-toastify/dist/ReactToastify.css";

import TicketList from "./survey-ui/views/pages/tickets/TicketList";
import TicketDetail from "./survey-ui/views/pages/tickets/TicketDetail";

window.modulePermissions = {
  "M1":{"name":"Survey","view":0,"add":0,"edit":0,"del":0},
  "M2":{"name":"Analytics","view":0},
  "M3":{"name":"Settings : User Management : Users","view":0,"add":0,"edit":0,"del":0},
  "M4":{"name":"Settings : User Management : Roles","view":0,"add":0,"edit":0,"del":0},
  "M5":{"name":"Settings : User Management : Teams","view":0,"add":0,"edit":0,"del":0},
  "M6":{"name":"Leads","view":0,"add":0,"edit":0,"del":0},
  "M7":{"name":"Tickets","view_own":0,"view_all":0,"comment":0},
  "M8":{"name":"Settings : General Settings : Organization Details","view":0,"add":0,"edit":0,"del":0},
  "M9":{"name":"Settings : General Settings : Security","view":0,"add":0,"edit":0,"del":0},
  "M10":{"name":"Settings : General Settings : Ticket Notifications","view":0,"add":0,"edit":0,"del":0},
  "M11":{"name":"Survey : Q&A Builder","view":0,"add":0,"edit":0,"del":0},
  "M12":{"name":"Survey : Form Builder","view":0,"add":0,"edit":0,"del":0},
  "M13":{"name":"Survey : Report Builder","view":0,"add":0,"edit":0,"del":0},
  "M14":{"name":"Survey : Email Templates","view":0,"edit":0},
  "M15":{"name":"Survey : Variables","view":0,"add":0,"edit":0,"del":0},
  "M16":{"name":"Survey : Publish & Share","view":0,"add":0,"edit":0,"del":0},
  "M17":{"name":"Survey : Integration","view":0,"edit":0},
  "M18":{"name":"Survey : Webhooks","view":0,"add":0,"edit":0,"del":0},
  "M19":{"name":"Survey : Privacy Policy","view":0,"edit":0},
  "M20":{"name":"Survey : Cookie Policy","view":0,"edit":0},
  "M21":{"name":"Survey : Questionnaire","view":0,"edit":0},
  "M22":{"name":"Survey : ThankYouPage","view":0,"edit":0},
  "M23":{"name":"Survey : Lead Erasure Rules","view":0,"add":0,"edit":0,"del":0}
};

const App = () => {

  const location = useLocation();
  const dispatch = useDispatch()

  //SurveyId remover
  useEffect(() => {
    if (location) {
      const [_, first, second, ...other] = location.pathname?.split('/')
      if (first === 'admin' && second === 'survey' && location.pathname !== '/admin/survey/list') {
        // console.log('-----', first, second)
      } else {
        dispatch({ type: SET_SURVEY_ID, payload: '' })
        dispatch({ type: SET_SURVEY_NAME, payload: null })
      }
    }
  }, [location])


  return (
    <>
      <ToastContainer />
      <PersistGate loading={null} persistor={persistor}>
        <Routes>
          <Route exact path="/" element={<Login />}> </Route>
          <Route exact path="/admin/login" element={<Login />} />
          <Route exact path="/admin/forgot-password" element={<ForgotPassword />}> </Route>
          <Route exact path="/admin/forgot-password/confirmation" element={<ForgetPasswordConfirmation />}> </Route>
          <Route exact path="/admin/verify-email" element={<VerifyEmail />}> </Route>
          <Route exact path="/admin/reset-password" element={<ResetPassword />}> </Route>
          <Route exact path="/admin/password-changed" element={<PasswordChanged />}> </Route>
          <Route exact path="/admin/signup" element={<SignUp />}> </Route>
          <Route exact path="/EmailVerification" element={<EmailVerification />}> </Route>
          <Route exact path="/admin/signup/verify-email" element={<SignUpVerifyEmail />}> </Route>
          <Route exact path="/admin/email-verification" element={<LoginOtpVerification />}> </Route>
          <Route exact path="/admin/mfa-verification" element={<MfaVerification />} />
          <Route exact path="/admin/password-expired" element={<PasswordExpired />} />
          {/* To Be Removed  */}
          <Route exact path="/AccountSetUp" element={<AccountSetUp />}> </Route>
          <Route exact path="/AccountSetUpGl" element={<AccountSetUpGl />}> </Route>
          <Route exact path="/OnBoardingScreen" element={<OnBoardingScreen />}> </Route>
          <Route exact path="/ProcessDone" element={<ProcessDone />}> </Route>
          <Route exact path="/InvitationEmail" element={<InvitationEmail />}> </Route>
          <Route exact path="/team-verification" element={<TeamVerification />}> </Route>
          <Route exact path="/team-invitation" element={<TeamInvitation />}> </Route>
          <Route exact path="/TeamAccountSetUp" element={<TeamAccountSetUp />}> </Route>
          <Route exact path="/TeamOnBoardingScreen" element={<TeamOnBoardingScreen />}> </Route>
          <Route exact path="/TeamProcessDone" element={<TeamProcessDone />}> </Route>
          <Route exact path="/JoinExistingAccount" element={<JoinExistingAccount />}> </Route>
          <Route exact path="/AccountSetUpSignUp" element={<AccountSetUpSignUp />}> </Route>
          <Route exact path="/JoiningRequestExistingAccount" element={<JoiningRequestExistingAccount />}> </Route>

            <Route exact path="/admin/survey" element={<AdminSurveyLayout />}>
            <Route exact path="/admin/survey/list" element={<SurveyList />}> </Route>
            <Route exact path="/admin/survey/groups" element={<SurveyGroup />}> </Route>
            <Route exact path="/admin/survey/groups/:groupId" element={<GroupSurveyList />}> </Route>
            <Route exact path="/admin/survey/create/qa-builder" element={<QnaTemplates />}> </Route>
            <Route exact path="/admin/survey/design" element={<Index />}> </Route>

            <Route exact path="/admin/survey/share" element={<Share />}> </Route>
            <Route exact path="/admin/survey/groups/:groupId/share" element={<GroupShare />}> </Route>
            <Route exact path="/admin/survey/integrations" element={<Integrations />}> </Route>
            <Route exact path="/admin/survey/integration/eloqua-settings" element={<EloquaSettings />} />
            <Route exact path="/admin/survey/thank-you-pages" element={<ThankYouPages />} />
            <Route exact path="/admin/survey/questionaire" element={<Questionaire />} />

          </Route>
          {/* <Route exact path="/admin/survey/share" element={<Share />} /> */}
          <Route exact path="/admin/survey/form-builder" element={<FormBuilder />} />

          <Route exact path="/admin/survey/create/lead-gen-variables" element={<Variables />}> </Route>
          <Route exact path="/admin/survey/create/custom-variable" element={<CustomVariable />}> </Route>
          <Route exact path="/admin/survey/create/custom-formulas" element={<CustomFormulas />}> </Route>
          <Route exact path="/admin/survey/create/utm-campaign" element={<UTMCampaignValues />}> </Route>
          <Route exact path="/admin/survey/create/stages" element={<Stages />}> </Route>



          <Route exact path="/admin/survey/create/configuration" element={<Configuration />} />
          <Route exact path="/admin/survey/webhooks" element={<Webhooks />} />
          <Route exact path="/admin/survey/lead-erasure-rules" element={<LeadErasureRules />} />
          <Route exact path="/admin/survey/privacy-policy-new" element={<PrivacyPolicyNew />} />
          <Route exact path="/admin/survey/cookie-policy" element={<CookiePolicyPage />} />

          <Route exact path="/admin/survey/create/language" element={<DefaultLanguage />} />
          <Route exact path="/admin/survey/create/translation" element={<Translation />} />

          <Route exact path="/admin/survey/report/builder" element={<RecentReports />} />
          <Route exact path="/admin/survey/report/templates" element={<Templates />} />
          <Route exact path="/admin/survey/email-template" element={<EmailTemplateEditor />} />

          <Route exact path="/admin/survey/question-logic" element={<QuestionLogic />} />

          <Route exact path="/admin/survey/template/landing-page" element={<LandingPage />} />
          <Route exact path="/admin/survey/template/landing-page/design" element={<DesignLandingPage />} />


          <Route exact path="/admin/survey/template/landing-page/survey-landing-page" element={<SimpleLandingPage />} />
          <Route exact path="/admin/survey/template/landing-page/detailed-landing-page" element={<DetailedLandingPage />} />
          <Route exact path="/admin/survey/template/landing-page/simple-form-landing-page" element={<SimpleFormLandingPage />} />
          <Route exact path="/admin/survey/template/landing-page/widget-form-landing-page" element={<WidgetFormLandingPage />} />

          <Route exact path="/admin/survey/preview" element={<Preview />} />

          <Route exact path="/admin/survey/template/thank-you" element={<ThankyouPage />} />
          <Route exact path="/admin/survey/template/thank-you/design" element={<DesignThankyouPage />} />


          {/* <Route exact path="/ckeditor" element={<EditorMultipleChoice />}> </Route> */}
          <Route exact path="/build" element={<BuildOnBoarding />} />


          <Route exact path="/admin/dashboard" element={<Dashboard />} />
          <Route exact path="/admin/analytics" element={<Analytics />} />
          <Route exact path="/admin/analytics/leads" element={<Leads />} />

          <Route exact path="/admin/settings/profile" element={<Profile />} />
          <Route exact path="/admin/settings/user-roles" element={<UserRoles />} />
          <Route exact path="/admin/settings/user-permissions" element={<UserPermissions />} />
          <Route exact path="/admin/settings/teams/list" element={<Teams />} />
          <Route exact path="/admin/settings/teams/create" element={<CreateTeam />} />
          <Route exact path="/admin/settings/teams/edit" element={<EditTeam />} />
          <Route exact path="/admin/settings/notification" element={<Notifications />} />
          <Route exact path="/admin/settings/security" element={<SecuritySettings />} />
          <Route exact path="/admin/settings/ticket-notifications" element={<TicketNotificationSettings />} />
          <Route exact path="/admin/settings/organization-details/privacy-policy" element={<OrganizationDetails />} />
          <Route exact path="/admin/settings/organization-details/terms-of-use" element={<OrganizationDetails />} />
          <Route exact path="/admin/settings/organization-details/cookie-policy" element={<OrganizationDetails />} />
          <Route exact path="/admin/settings/activity-log-template" element={<ActivityLogTemplate />} />
          <Route exact path="/admin/settings/fonts" element={<Fonts />} />

          <Route exact path="/admin/survey/create/start" element={<NewSurveyQuestionaire />} />

          <Route exact path="/admin/terms" element={<Terms />} />
          <Route exact path="/admin/privacy-policies" element={<PrivacyPolicies />} />

          {/* <Route exact path="/admin/ducumentation/component/documentationsidebar" element={<DocumentationSidebar />} /> */}
          <Route exact path="/admin/ducumentation/surveys/create-survey" element={<CreateSurvey />} />
          <Route exact path="/admin/ducumentation/surveys/document-dashboard" element={<DocumentDashboard />} />
          <Route exact path="/admin/ducumentation/surveys/document-formbuilder" element={<DocumentFormBuilder />} />
          <Route exact path="/admin/ducumentation/surveys/document-publishshare" element={<DocumentPublishShare />} />
          <Route exact path="/admin/ducumentation/surveys/document-integration" element={<DocumentIntegration />} />
          <Route exact path="/admin/ducumentation/surveys/document-webhook" element={<DocumentWebhook/>} />
          <Route exact path="/admin/ducumentation/surveys/document-qandabuilder" element={<DocumentQandABuilder />} />
          <Route exact path="/admin/ducumentation/surveys/document-questionnarire" element={<DocumentQuestionnarire />} />
          <Route exact path="/admin/ducumentation/surveys/document-reportbuilder" element={<DocumentReportBuilder />} />
          <Route exact path="/admin/ducumentation/surveys/document-emailtemplates" element={<DocumentEmailTemplates />} />
          <Route exact path="/admin/ducumentation/surveys/document-thankyoupage" element={<DocumentThankYouPage />} />
          <Route exact path="/admin/ducumentation/surveys/document-leaderasure" element={<DocumentLeadErasureRules />} />
          <Route exact path="/admin/ducumentation/surveys/document-privacypolicy" element={<DocumentPrivacyPolicy />} />
          <Route exact path="/admin/ducumentation/surveys/document-cookiepolicy" element={<DocumentCookiePolicy />} />
          <Route exact path="/admin/ducumentation/surveys/document-variables" element={<DocumentVariables />} />
          <Route exact path="/admin/ducumentation/surveys/document-recomadation" element={<DocumentRecomadation />} />
          <Route exact path="/admin/ducumentation/surveys/document-surveygroups" element={<DocumentSurveyGroups />} />
          <Route exact path="/admin/ducumentation/surveys/document-surveysync" element={<DocumentSurveySync />} />
          <Route exact path="/admin/ducumentation/settings/document-accountsetting" element={<DocumentAccountSetting />} />
          <Route exact path="/admin/ducumentation/settings/document-security" element={<DocumentSecuritySettings />} />
          <Route exact path="/admin/ducumentation/settings/document-ticket-notifications" element={<DocumentTicketNotificationSettings />} />
          <Route exact path="/admin/ducumentation/settings/document-roles" element={<DocumentRoles />} />
          <Route exact path="/admin/ducumentation/settings/document-teams" element={<DocumentTeams />} />
          <Route exact path="/admin/ducumentation/settings/document-users" element={<DocumentUsers />} />
          <Route exact path="/admin/ducumentation/settings/document-organization-details" element={<DocumentOrganizationDetails />} />
          <Route exact path="/admin/ducumentation/settings/document-organization-details/privacy-policy" element={<DocumentOrganizationDetails />} />
          <Route exact path="/admin/ducumentation/settings/document-organization-details/terms-of-use" element={<DocumentOrganizationDetails />} />
          <Route exact path="/admin/ducumentation/settings/document-organization-details/cookie-policy" element={<DocumentOrganizationDetails />} />
          <Route exact path="/admin/ducumentation/document-analytics" element={<DocumentAnalytics />} />
           <Route exact path="/admin/ducumentation/document-ActivityLogs" element={< DocumentActivityLog/>} />
           <Route exact path="/admin/ducumentation/document-tickets" element={<DocumentTickets />} />
            <Route exact path="/admin/activity-logs" element={<ActivityLogs />} />

          <Route exact path="/admin/tickets" element={<TicketList />} />
          <Route exact path="/admin/tickets/:ticketId" element={<TicketDetail />} />

        </Routes>
      </PersistGate>

      {/* 
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer /> 
      */}

    </>

  );
};
export default App;